import { render, staticRenderFns } from "./SwitchExpression.vue?vue&type=template&id=27945472"
import script from "./SwitchExpression.vue?vue&type=script&lang=js"
export * from "./SwitchExpression.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports